import { useTranslation } from 'react-i18next';

import { Chip, Stack, Typography } from '@mui/material';
import CustomTooltip from 'common/components/CustomTooltip';
import useFlexBoxStyles from 'common/flexBox';

const MyAvailabilityDayChips = (props) => {
    const { availability } = props;
    const { t } = useTranslation();
    const { classes: fleBox, cx } = useFlexBoxStyles();
    const workingHours = availability?.weeklySchedule;

    const getRow = (day) => {
        const items = workingHours?.[day];
        if (!items || items.length === 0) return null;

        const sortedItems = items.sort((a, b) => a.startTime.localeCompare(b.startTime));

        return (
            <div style={{ whiteSpace: 'pre-line' }}>
                {sortedItems.map((item, idx) => (
                    <div key={idx}>
                        {item.startTime} - {item.endTime}
                    </div>
                ))}
            </div>
        );
    };

    const days = [
        { id: 'sunday', title: t('app.common.days.sunday'), content: getRow(0) },
        { id: 'monday', title: t('app.common.days.monday'), content: getRow(1) },
        { id: 'tuesday', title: t('app.common.days.tuesday'), content: getRow(2) },
        { id: 'wednesday', title: t('app.common.days.wednesday'), content: getRow(3) },
        { id: 'thursday', title: t('app.common.days.thursday'), content: getRow(4) },
        { id: 'friday', title: t('app.common.days.friday'), content: getRow(5) },
        { id: 'saturday', title: t('app.common.days.saturday'), content: getRow(6) },
    ];

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
            {days.map((day) => (
                <CustomTooltip
                    arrow
                    title={day.content}
                    placement="bottom"
                    disableHoverListener={days.content === null}
                >
                    <Typography variant="onliveH6" fontWeight={600}>
                        <Chip
                            size="small"
                            label={day.title}
                            key={day.id}
                            color={day.content ? 'success' : 'default'}
                            className={cx(day.content ? fleBox.cursorPointer : fleBox.cursorNoAllowed)}
                        />
                    </Typography>
                </CustomTooltip>
            ))}
        </Stack>
    );
};

export default MyAvailabilityDayChips;
